// DataContext.js
import { createContext, useState, useEffect } from 'react';
import { fetch_dynamic_config } from '../services/configserver.js'
import { ConfigContext } from '../ConfigContext.jsx'



export const ConfigCtxtProvider = ({ children }) => {
    const [data, setData] = useState({});

    useEffect(() => {
 
        fetch_dynamic_config(
            'moogys_website_bootstrap_data',
                (config) => {
                    const isTrulyEmpty = config && Object.keys(config).length === 0 && config.constructor === Object
                    console.log('fetched dynamic config for context provider:', config, 'is empty object?', isTrulyEmpty)
                    setData(config)
                },
                (err) => console.log('error fetching dynamic config:', err)
        )
        console.log('config data in context provider:', data)
    }, []);

    const value = {
        bootstrapConfig: data
    };

    
    return (
        <ConfigContext.Provider value={value} >
            {children}
        </ConfigContext.Provider>
    );
};
